import { render, staticRenderFns } from "./stationeryRecord-content-item.vue?vue&type=template&id=0ab0a058&scoped=true"
import script from "./stationeryRecord-content-item.vue?vue&type=script&lang=js"
export * from "./stationeryRecord-content-item.vue?vue&type=script&lang=js"
import style0 from "./stationeryRecord-content-item.vue?vue&type=style&index=0&id=0ab0a058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0a058",
  null
  
)

export default component.exports